import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cx } from "../lib/cx.js";
const paths = {
    home: "M4 10.5 12 4l8 6.5V20a1 1 0 0 1-1 1h-5v-6H10v6H5a1 1 0 0 1-1-1z",
    payslip: "M7 3h7l4 4v14H7zM14 3v4h4M9 12h6M9 16h4",
    calendar: "M7 4v3M17 4v3M5 8h14M6 5h12a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1z",
    clock: "M12 7v5l3 2M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16z",
    inbox: "M4 13h4l2 2h4l2-2h4v6H4zM4 5h16v8",
    document: "M7 3h7l4 4v14H7zM14 3v4h4M9 13h6M9 17h4",
    megaphone: "M4 14v-4l10-4v12zM14 8.5c1.5.8 3.5 1 5 .7M14 15.5c1.5-.8 3.5-1 5-.7M6 14v4a2 2 0 0 0 2 0",
    gift: "M4 10h16v10H4zM12 10v10M4 10V8h16v2M12 8c-2-3-5-1-4 1M12 8c2-3 5-1 4 1",
    users: "M16 21v-2a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v2M9.5 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM17 11a3 3 0 1 0 0-6M21 21v-2a3.5 3.5 0 0 0-3-3.4",
    "check-circle": "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16zM8.5 12.5l2.5 2.5 4.5-5",
    chart: "M4 19h16M7 16v-5M12 16V8M17 16v-8",
    folder: "M4 7h6l2 2h8v10H4z",
    sitemap: "M9 5h6v4H9zM4 15h6v4H4zM14 15h6v4h-6zM12 9v6M7 15V12h10v3",
    plug: "M8 6v5M16 6v5M7 11h10v3a5 5 0 0 1-10 0zM12 19v2",
    flag: "M5 21V4m0 0h10l-2 4 2 4H5",
    user: "M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM5 20a7 7 0 0 1 14 0",
    settings: "M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM19.4 15a7.8 7.8 0 0 0 .1-2l2-1.5-2-3.5-2.4.5a8 8 0 0 0-1.7-1L15 4h-6l-.4 2.5a8 8 0 0 0-1.7 1L8.5 8 4.5 8.5l-2 3.5 2 1.5a7.8 7.8 0 0 0 .1 2l-2 1.5 2 3.5 2.4-.5a8 8 0 0 0 1.7 1L9 20h6l.4-2.5a8 8 0 0 0 1.7-1l2.4.5 2-3.5z",
    search: "M11 5a6 6 0 1 0 0 12 6 6 0 0 0 0-12zM20 20l-3.5-3.5",
    filter: "M4 6h16M7 12h10M10 18h4",
    "chevron-down": "M6 9l6 6 6-6",
    "chevron-up": "M6 15l6-6 6 6",
    "chevron-left": "M15 6l-6 6 6 6",
    "chevron-right": "M9 6l6 6-6 6",
    "arrow-right": "M5 12h14M13 6l6 6-6 6",
    external: "M14 5h5v5M19 5l-9 9M10 5H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-4",
    alert: "M12 9v4M12 17h.01M10.3 5.5 3.6 17.2A2 2 0 0 0 5.3 20h13.4a2 2 0 0 0 1.7-2.8L13.7 5.5a2 2 0 0 0-3.4 0z",
    shield: "M12 3 5 6v6c0 4.5 3 7.5 7 9 4-1.5 7-4.5 7-9V6z",
    bell: "M6 16h12l-1-2V10a5 5 0 0 0-10 0v4zM10 16a2 2 0 0 0 4 0",
    building: "M5 21V5h10v16M15 9h4v12M9 9v.01M9 13v.01M9 17v.01",
    "log-out": "M10 17H6a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h4M14 16l5-4-5-4M19 12H10",
    more: "M6 12h.01M12 12h.01M18 12h.01",
    close: "M6 6l12 12M18 6 6 18",
    plus: "M12 6v12M6 12h12",
    copy: "M8 8h10v12H8zM6 16H5V4h10v1",
    info: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16zM12 11v5M12 8h.01",
    warning: "M12 9v4M12 17h.01M10.3 5.5 3.6 17.2A2 2 0 0 0 5.3 20h13.4a2 2 0 0 0 1.7-2.8L13.7 5.5a2 2 0 0 0-3.4 0z",
    success: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16zM8.5 12.5l2.5 2.5 4.5-5",
    menu: "M5 7h14M5 12h14M5 17h14",
    columns: "M5 5h5v14H5zM14 5h5v14h-5z",
    download: "M12 4v12M7 11l5 5 5-5M5 19h14",
    refresh: "M20 12a8 8 0 1 1-2.3-5.6M20 4v5h-5",
    check: "M5 12.5 9.5 17 19 7.5",
};
export function isIconName(name) {
    return name in paths;
}
export function Icon({ name, size = 20, title, className, ...rest }) {
    return (_jsxs("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.75, strokeLinecap: "round", strokeLinejoin: "round", className: cx("evolua-icon", className), "aria-hidden": title ? undefined : true, role: title ? "img" : undefined, ...rest, children: [title ? _jsx("title", { children: title }) : null, _jsx("path", { d: paths[name] })] }));
}
//# sourceMappingURL=Icon.js.map